import { reactive } from 'vue';

/**
 * Toast global do jogo.
 *
 * `this.$toast.success(...)` ja era chamado em 31 pontos (loja premium, arena,
 * ginasio, painel admin, modais de treino e descanso), mas nada nunca registrou
 * `$toast`: nao ha plugin de toast nas dependencias e o main.js so instalava
 * gtag, store, router e i18n. Toda chamada estourava
 * "Cannot read properties of undefined (reading 'success')" — e como a maioria
 * delas fica logo depois de uma acao dar certo, o erro engolia o resto do metodo.
 *
 * A implementacao e deliberadamente pequena: uma fila reativa que o
 * `ToastHost.vue` desenha. Quem vive fora de um componente (modulos do Vuex)
 * importa `toast` direto deste arquivo.
 */

const DURACAO_PADRAO_MS = 4000;

export const toasts = reactive([]);

let proximoId = 1;

function mostrar(type, message, duration = DURACAO_PADRAO_MS) {
  if (!message) return null;

  const id = proximoId++;
  toasts.push({ id, type, message: String(message) });

  setTimeout(() => remover(id), duration);

  return id;
}

export function remover(id) {
  const i = toasts.findIndex((t) => t.id === id);
  if (i !== -1) toasts.splice(i, 1);
}

export const toast = {
  success: (message, duration) => mostrar('success', message, duration),
  error: (message, duration) => mostrar('error', message, duration),
  warning: (message, duration) => mostrar('warning', message, duration),
  info: (message, duration) => mostrar('info', message, duration),
  show: (message, duration) => mostrar('info', message, duration)
};

export default {
  install(app) {
    app.config.globalProperties.$toast = toast;
  }
};
